import "./header.css";
import { GrMenu } from "react-icons/gr";
import Button from "antd/lib/button";
import Logo1 from "../../assets/icons/logo1";
import Modal from "antd/lib/modal";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMdLogOut } from "react-icons/io";
import NotificationIcon from "../../assets/icons/notificationIcon";
import { useDispatch } from "react-redux";
import {
  setCreateCouponModal,
  setLogoutModal,
} from "../../features/app/app_slice";
import { FaArrowLeft } from "react-icons/fa6";
import version from "../../constant/version.json";
import Env from "../../constant/env.json";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [menuModal, setMenuModal] = useState(false);

  return (
    <>
      {location.pathname === "/dashboard" ||
      location.pathname === "/courses" ||
      location.pathname === "/courses/new" ||
      location.pathname.includes("/courses/edit") ||
      location.pathname.includes("/courses/view") ||
      location.pathname === "/community" ||
      location?.pathname?.includes("/community/") ||
      location.pathname === "/faqs" ||
      location.pathname === "/setting" ||
      location.pathname === "/transactions" ||
      location.pathname === "/statistics" ||
      location.pathname === "/coupons" ? (
        <>
          <header className="header">
            {location.pathname === "/dashboard" ? <h2>Dashboard</h2> : null}
            {location.pathname === "/courses" ? <h2>My courses</h2> : null}
            {location.pathname === "/courses/new" ? <h2>New Course</h2> : null}
            {location.pathname.includes("/courses/edit") ? (
              <h2>Edit Course</h2>
            ) : null}
            {location.pathname.includes("/courses/view") ? (
              <h2>Course Preview</h2>
            ) : null}
            {location.pathname === "/community" ? <h2>Community</h2> : null}
            {location?.pathname?.includes("/community/") ? <h2>Post</h2> : null}
            {location.pathname === "/faqs" ? <h2>FAQs</h2> : null}
            {location.pathname === "/setting" ? <h2>Setting</h2> : null}
            {location.pathname === "/transactions" ? (
              <h2>Transactions</h2>
            ) : null}
            {location.pathname === "/statistics" ? <h2>Statistics</h2> : null}
            {location.pathname === "/coupons" ? <h2>Coupons</h2> : null}

            {location.pathname === "/dashboard" ||
            location.pathname === "/courses" ? (
              <Button
                onClick={() => {
                  navigate("/courses/new");
                }}
              >
                Add new course
              </Button>
            ) : location.pathname === "/coupons" ? (
              <Button
                onClick={() => {
                  dispatch(setCreateCouponModal(true));
                }}
              >
                Add new coupon
              </Button>
            ) : null}
          </header>
          <header className="header_mobile">
            <Button
              className="menu_logo_mobile"
              onClick={() => {
                if (
                  location.pathname == "/courses/new" ||
                  location.pathname.includes("/courses/edit") ||
                  location.pathname.includes("/courses/view")
                ) {
                  navigate("/courses");
                } else if (location.pathname?.includes("/community/")) {
                  navigate(-1);
                } else {
                  setMenuModal(true);
                }
              }}
            >
              {location.pathname == "/courses/new" ||
              location.pathname.includes("/community/") ||
              location.pathname.includes("/courses/edit") ||
              location.pathname.includes("/courses/view") ? (
                <FaArrowLeft />
              ) : (
                <GrMenu />
              )}
            </Button>
            <Link to={"/dashboard"}>
              <Logo1 />
            </Link>
          </header>
        </>
      ) : null}

      {/* menuModal */}
      <Modal
        open={menuModal}
        onCancel={() => setMenuModal(false)}
        footer={null}
        className="menuModal"
        closeIcon={null}
      >
        <div className="menu_modal_container">
          {/* menu_modal_title */}
          <div className="menu_modal_title">
            <Button onClick={() => setMenuModal(false)}>
              <IoClose />
            </Button>
            <Link
              onClick={() => {
                setMenuModal(false);
              }}
              to={"/dashboard"}
            >
              <Logo1 alt="logo" />
            </Link>
          </div>
          {/* navbar */}
          <div className="navbar">
            <Link
              className={
                location.pathname == "/dashboard" ? "active_menu" : null
              }
              to={"/dashboard"}
            >
              Dashboard
            </Link>
            <Link
              className={
                location.pathname == "/courses" ||
                location.pathname == "/courses/new" ||
                location.pathname.includes("/courses/edit") ||
                location.pathname.includes("/courses/view")
                  ? "active_menu"
                  : null
              }
              to={"/courses"}
            >
              My courses
            </Link>
            <Link
              className={location.pathname == "/coupons" ? "active_menu" : null}
              to={"/coupons"}
            >
              Coupons
            </Link>
            <Link
              className={
                location.pathname == "/transactions" ? "active_menu" : null
              }
              to={"/transactions"}
            >
              Transactions
            </Link>
            {/* <Link
              className={
                location.pathname == "/statistics" ? "active_menu" : null
              }
              to={"/statistics"}
            >
              Statistics
            </Link> */}
            <Link
              className={
                location.pathname == "/community" ? "active_menu" : null
              }
              to={"/community"}
            >
              Community
            </Link>
            <Link
              className={location.pathname == "/setting" ? "active_menu" : null}
              to={"/setting"}
            >
              Setting
            </Link>
            <Link
              className={location.pathname == "/faqs" ? "active_menu" : null}
              to={"/faqs"}
            >
              FAQs
            </Link>
          </div>
          {/* notif_logout_btn */}
          <div className="notif_logout_btn">
            {/* <div className="notif_btn">
              <Button>
                <NotificationIcon />
                <span>Notifications</span>
              </Button>
              <div>2</div>
            </div> */}
            <Button
              onClick={() => {
                dispatch(setLogoutModal(true));
                setMenuModal(false);
              }}
              className="logout_btn"
            >
              <IoMdLogOut />
              <span>Logout</span>
            </Button>
            <span>
              version {version.version}
              {Env.base_url == "https://devapi.naranel.com/api/" ? (
                <span
                  className="font-medium"
                  style={{ fontStyle: "italic", marginLeft: 8 }}
                >
                  (development)
                </span>
              ) : null}
            </span>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Header;
